import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import EnrollmentCapacitacionServices from "./Enrollment.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCourses = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_COURSES,
      payload: true,
    });
    const resp = await EnrollmentCapacitacionServices.getCourses(filters);
    dispatch({
      type: actions.GET_COURSES,
      payload: resp.data,
    });
    dispatch({
      type: actions.COURSES_FAIL,
      payload: null,
    });
  } catch (error) {
    handleError(error, dispatch, actions.COURSES_FAIL);
  } finally {
    dispatch({
      type: actions.LOADER_COURSES,
      payload: false,
    });
  }
};

export const createCourse = (data) => async (dispatch) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_COURSES,
      payload: true,
    });
    await EnrollmentCapacitacionServices.createCourse(data);

    dispatch({
      type: actions.FORM_COURSES_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage);
    return true;
  } catch (error) {
    handleError(error, dispatch, actions.FORM_COURSES_FAIL);
    return false;
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_COURSES,
      payload: false,
    });
  }
};

export const editCourse = (id, data) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_COURSES,
      payload: true,
    });

    await EnrollmentCapacitacionServices.editCourse(id, data);

    dispatch({
      type: actions.COURSES_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage);
    return true;
  } catch (error) {
    handleError(error, dispatch, actions.COURSES_FAIL);
    return false;
  } finally {
    dispatch({
      type: actions.LOADER_COURSES,
      payload: false,
    });
  }
};

export const cancelCourse = (id, data) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_COURSES,
      payload: true,
    });
    await EnrollmentCapacitacionServices.cancelCourse(id, data);

    toastr.success(messages.successMessage);
    return true;
  } catch (error) {
    handleError(error, dispatch, actions.COURSES_FAIL);
  } finally {
    dispatch({
      type: actions.LOADER_COURSES,
      payload: false,
    });
  }
};

export const getRegisteredEmployees = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_REGISTERED_EMPLOYEES,
      payload: true,
    });

    const resp = await EnrollmentCapacitacionServices.getRegistered(id);

    dispatch({
      type: actions.GET_REGISTERED_EMPLOYEES,
      payload: resp.data,
    });

    dispatch({
      type: actions.REGISTERED_EMPLOYEES_FAIL,
      payload: null,
    });

    return resp.data;
  } catch (error) {
    handleError(error, dispatch, actions.REGISTERED_EMPLOYEES_FAIL);
    throw error;
  } finally {
    dispatch({
      type: actions.LOADER_REGISTERED_EMPLOYEES,
      payload: false,
    });
  }
};

export const getCoursesEmployees = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_COURSES_EMPLOYEES,
      payload: true,
    });
    const resp = await EnrollmentCapacitacionServices.getCoursesEmployees(
      filters
    );
    dispatch({
      type: actions.GET_COURSES_EMPLOYEES,
      payload: resp.data,
    });
    dispatch({
      type: actions.COURSES_EMPLOYEES_FAIL,
      payload: null,
    });
  } catch (error) {
    handleError(error, dispatch, actions.COURSES_EMPLOYEES_FAIL);
  } finally {
    dispatch({
      type: actions.LOADER_COURSES_EMPLOYEES,
      payload: false,
    });
  }
};

export const newEnrollmentEmployee = (data) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_ENROLLMENT,
      payload: true,
    });
    const resp = await EnrollmentCapacitacionServices.newEnrollmentEmployee(
      data
    );
    dispatch({
      type: actions.ENROLLMENT_SUCCESS,
      payload: resp.data,
    });
    dispatch({
      type: actions.ENROLLMENT_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage);
    return resp.data;
  } catch (error) {
    handleError(error, dispatch, actions.ENROLLMENT_FAIL);
    throw error;
  } finally {
    dispatch({
      type: actions.LOADER_ENROLLMENT,
      payload: false,
    });
  }
};

export const getEnrolledEmployees = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_ENROLLED_EMPLOYEES,
      payload: true,
    });

    const resp = await EnrollmentCapacitacionServices.getEnrolledEmployees(id);

    dispatch({
      type: actions.GET_ENROLLED_EMPLOYEES,
      payload: resp.data,
    });

    dispatch({
      type: actions.ENROLLED_EMPLOYEES_FAIL,
      payload: null,
    });

    return resp.data;
  } catch (error) {
    handleError(error, dispatch, actions.ENROLLED_EMPLOYEES_FAIL);
    throw error;
  } finally {
    dispatch({
      type: actions.LOADER_ENROLLED_EMPLOYEES,
      payload: false,
    });
  }
};

export const approveEnrollment = (data) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_APPROVE_ENROLLMENT,
      payload: true,
    });

    const resp = await EnrollmentCapacitacionServices.postPassEnrollment(data);

    dispatch({
      type: actions.APPROVE_ENROLLMENT_SUCCESS,
      payload: resp.data,
    });

    toastr.success(messages.successMessage);
    return resp.data;
  } catch (error) {
    handleError(error, dispatch, actions.APPROVE_ENROLLMENT_FAIL);
    throw error;
  } finally {
    dispatch({
      type: actions.LOADER_APPROVE_ENROLLMENT,
      payload: false,
    });
  }
};

const handleError = (error, dispatch, actionType) => {
  let message = null;
  if (axios.isAxiosError(error)) {
    if (error.response?.status) {
      switch (error.response.status) {
        case 400:
          message =
            error.response.data.mensaje ||
            error.response.data.detail ||
            error.response.data.error;
          break;
        case 404:
          message = error.response.data?.mensaje || messages.notFound;
          break;
        case 403:
          message = error.response.data?.detail || messages.forbidden;
          break;
        case 500:
          message = messages.errorMessage + " " + error.response.statusText;
          break;
        default:
          message = error.response.data || messages.errorMessage;
          break;
      }
    } else {
      message =
        error.message === "Network Error"
          ? messages.networkError
          : error.message;
    }
  } else {
    message =
      error.message === "Network Error" ? messages.networkError : error.message;
  }
  dispatch({ type: actionType, payload: message });
  toastr.error(message);
};
